<template>
  <GeneralModal
    ref="modalSelectOfficeRef"
    :title="'Selecciona sucursal'"
    size="lg"
    @shown="onShown"
    modalContentClass="p-4"
    hideHeaderClose
    hideFooter
  >
    <template #bodyContent>
      <form @submit.prevent="submit()">
        <div class="row mb-3">
          <div class="col-12">
            <OfficeCardSelector
              ref="officeCardSelectorRef"
              :class="{ 'is-invalid': errors.selectedOffices }"
              :offices="offices"
              v-model:selectedOffices="selectedOffices"
            />
            <div class="invalid-feedback" v-text="errors.selectedOffices"></div>
          </div>
        </div>
        <div class="d-flex justify-content-end col mt-3">
          <button class="btn btn-login-app w-50" type="submit">Guardar</button>
        </div>
      </form>
    </template>
  </GeneralModal>
</template>
<script setup>
import GeneralModal from '@/components/shared/GeneralModal.vue'
import OfficeCardSelector from '@/components/shared/OfficeCardSelector.vue'
import { ref, computed } from 'vue'
import { useField, useForm } from 'vee-validate'
import { object, array } from 'yup'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const officeCardSelectorRef = ref(null)

const offices = computed(() => userStore.offices)

const modalSelectOfficeRef = ref(null)

const onShown = () => {
  officeCardSelectorRef.value.toggleSelection(userStore.officeSelected)
}

const showModal = () => {
  modalSelectOfficeRef.value.show()
}

// eslint-disable-next-line no-unused-vars
const hideModal = () => {
  modalSelectOfficeRef.value.hide()
}

const getValidationSchema = computed(() => {
  const schema = {}
  schema.selectedOffices = array().required('Selecciona al menos una sucursal')

  return object(schema)
})

const validationSchema = getValidationSchema

const { handleSubmit, errors } = useForm({
  validationSchema
})

const { value: selectedOffices } = useField('selectedOffices')

const submit = handleSubmit(() => {
  userStore.setOfficeSelected(selectedOffices.value[0])
  hideModal()
})

defineExpose({
  showModal,
  hideModal
})
</script>
